import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

interface SwiperOnlyH5Props {
    items: {
        pc: string;
        pad?: string;
        h5?: string;
    }[];
}

const SwiperOnlyH5: React.FC<SwiperOnlyH5Props> = ({ items }) => {
    const swiperRef = useRef<any>(null);

    const handlePrev = () => {};
    const handleNext = () => {};

    return (
        <div className={styles.SwiperOnlyH5}>
            <div className="desktop-only">
                {items.map((item, index) => (
                    <EcoImg key={index} pc={item.pc} pad={item.pad} h5={item.h5} />
                ))}
            </div>
            <Swiper
                className="h5-only"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                slidesPerView={'auto'}
                spaceBetween={24}
                modules={[Navigation]}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                initialSlide={0}
                onSlideChange={(swiper) => {
                    // if (swiper.previousIndex < swiper.activeIndex) {
                    //     gtm.push({
                    //         event: 'uaEvent',
                    //         event_name: 'product_detail_page',
                    //         list_name: 'What Our EcoFlow Users Think',
                    //         button_name: 'Right switch',
                    //     });
                    // } else {
                    //     gtm.push({
                    //         event: 'uaEvent',
                    //         event_name: 'product_detail_page',
                    //         list_name: 'What Our EcoFlow Users Think',
                    //         button_name: 'Left switch',
                    //     });
                    // }
                }}
            >
                {items.map((item, index) => (
                    <SwiperSlide key={index} className="list-item">
                        <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                    </SwiperSlide>
                ))}
                <div className="swiper-button-prev" onClick={handlePrev} />
                <div className="swiper-button-next" onClick={handleNext} />
            </Swiper>
        </div>
    );
};

export default SwiperOnlyH5;
